import React from 'react'
import { SimpleImg } from 'react-simple-img'

const BannerInterior = ({titulo, imgsrc}) => {
	return (
		<div className="banner-interior">
			<div className="container">
				<div className="inner">
					<h1><span dangerouslySetInnerHTML={{ __html: titulo }}></span></h1>
				</div>
			</div>
			<div className="poster">
				<SimpleImg src={imgsrc} alt={titulo} width={1400} height={547} placeholder={false} />
			</div>
		</div>
	)
}

export default BannerInterior
